import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { TEndpoint } from 'contexts/app-context/types'
import { isEmpty } from 'lodash'

import { queryOptions } from '@tanstack/react-query'

import { IRequestTermsRequest, IRequestTermsResponse } from '../../types/useRequestTerms.types'

interface GetRequestTermsQueryParams {
  endpoint?: TEndpoint
  requestBody?: IRequestTermsRequest
}

export const getRequestTermsQueryKey = (requestBody?: IRequestTermsRequest) => [
  REACT_QUERY_KEYS.TERMS,
  requestBody,
]

export const getRequestTermsQueryOptions = ({
  endpoint,
  requestBody,
}: GetRequestTermsQueryParams) =>
  queryOptions({
    queryKey: getRequestTermsQueryKey(requestBody),
    queryFn: () => {
      if (!endpoint) throw new Error('No request terms endpoint available')
      if (isEmpty(requestBody)) throw new Error('No request body found')

      return bridgeRequest<IRequestTermsResponse>({
        endpoint,
        body: requestBody,
        returnAllResponse: false,
      })
    },
    enabled: !!endpoint && !isEmpty(requestBody),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  })
